<template>
  <el-dialog
    custom-class="success-dialog"
    title=""
    :visible.sync="isOpen"
    width="7rem"
    append-to-body
    :close-on-click-modal="true"
    :show-close="false"
  >
    <div class="sign-success">
      <img src="../../assets/image/login/success.png"/>
      <div class="sign-success_title">{{msg||"Submit completed!"}}</div>
      <div class="sign-success_tip" v-if="!noTip">Return within {{count}} seconds.</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props:["noTip","msg"],
  components: {},
  data() {
    return {
      isOpen: false,
      username:"",
      count:3,
    };
  },
  computed: {},
  methods: {
    open(username) {
      this.isOpen = true;
      this.username = username;
      this.count = 3;
      this.initTime();
    },
    initTime(){
      setTimeout(() => {
        if(this.count > 0){
          this.count --;
          this.initTime();
        }else{
          this.close();
        }
      },1000)
    },
    close() {
      this.isOpen = false;
      this.$emit("close")
    }
  },
  created() {},
  mounted() {},
  watch: {}
};
</script>
<style lang="scss" scoped>
.sign-success{
  text-align: center;
  padding-bottom:0.4rem;
  img{
    width:1.6rem;
    margin-bottom:0.4rem;
  }
  .sign-success_title{
    color:#000;
    font-size: 0.32rem;
    line-height: 0.4rem;
    font-weight: bold;
  }
  .sign-success_tip{
    color:#B4B4B4;
    font-size: 0.18rem;
    margin-top:0.12rem;
  }

}

</style>
